import React, { createContext, useReducer } from 'react';
import globalReducer from './globalReducer';

// Initial state
const initialState = {
  allReleases: [
  ],
  latestRelease: [
  ],
  rangeReleases:[
  ],
  selectedTimeRange:[
    "Max"
  ]

};

const GlobalContext = createContext(initialState);



// Provider component
const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalProvider };
